/**
 * Unified button type constants for templates (Twilio & WhatsApp)
 * These constants are shared across all template types
 */

/**
 * Call-to-Action button types
 */
export const BUTTON_TYPES = {
  URL: 'URL',
  PHONE_NUMBER: 'PHONE_NUMBER',
  COPY_CODE: 'COPY_CODE',
  VOICE_CALL: 'VOICE_CALL',
  VOICE_CALL_REQUEST: 'VOICE_CALL_REQUEST',
  QUICK_REPLY: 'QUICK_REPLY',
};

/**
 * Icon mapping for button types
 */
export const BUTTON_TYPE_ICONS = {
  [BUTTON_TYPES.URL]: 'i-lucide-link',
  [BUTTON_TYPES.PHONE_NUMBER]: 'i-lucide-phone',
  [BUTTON_TYPES.COPY_CODE]: 'i-lucide-copy',
  [BUTTON_TYPES.VOICE_CALL]: 'i-lucide-phone-call',
  [BUTTON_TYPES.VOICE_CALL_REQUEST]: 'i-lucide-phone-incoming',
  [BUTTON_TYPES.QUICK_REPLY]: 'i-lucide-reply',
};

/**
 * Get button icon by type
 * @param {string} type - Button type
 * @returns {string} Icon class name
 */
export const getButtonIcon = type => {
  return BUTTON_TYPE_ICONS[type] || 'i-lucide-mouse-pointer-click';
};
